import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class OrderSourceReferenceService extends BaseReferenceService {
  constructor() {
    super('OrderSourceReference');
  }
}
